export default "__VITE_ASSET__1108859b__"